import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '../common/dialog'
import { TextField } from '@mui/material'
import { textFieldWhiteBg } from '../../theme/custom-styles'
import { handleGetIfEmailIsValid } from '../../utils/common.utils'
import { FormError } from '../../types'

export const CreateCustomerCompanyComplianceUserModal = ({
  isLoading,
  generalError,
  handleOpenStateOfModal,
  handleCreateCustomerCompanyComplianceUser
}: {
  isLoading: boolean
  generalError: boolean
  handleOpenStateOfModal: (openState: boolean) => void
  handleCreateCustomerCompanyComplianceUser: ({ userEmailData, userFirstNameData, userLastNameData }: { userEmailData: string; userFirstNameData: string; userLastNameData: string }) => void
}) => {
  const { t } = useTranslation(['customer-company-details-management'])

  const [userEmailData, setUserEmailData] = useState('')
  const [userLastNameData, setUserLastNameData] = useState('')
  const [userFirstNameData, setUserFirstNameData] = useState('')
  const [errors, setErrors] = useState<{ generalError?: string; userEmailData?: string; userFirstNameData?: string; userLastNameData?: string } | null>(null)

  useEffect(() => {
    if (generalError) {
      setErrors({ generalError: t('customerCompanyManageModal.complianceUsersModal.errors.alreadyExists') })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalError])

  const handleSubmitPocketDataCreation = () => {
    if (isLoading) return

    setErrors(null)
    const errorsToSet = {} as { userEmailData?: string; userFirstNameData?: string; userLastNameData?: string }

    if (!userFirstNameData) {
      errorsToSet.userFirstNameData = t('customerCompanyManageModal.complianceUsersModal.errors.firstName')
    }

    if (!userLastNameData) {
      errorsToSet.userLastNameData = t('customerCompanyManageModal.complianceUsersModal.errors.lastName')
    }

    if (!userEmailData) {
      errorsToSet.userEmailData = t('customerCompanyManageModal.complianceUsersModal.errors.email')
    }

    if (userEmailData) {
      const isEmail = handleGetIfEmailIsValid(userEmailData)

      if (!isEmail) {
        errorsToSet.userEmailData = t('customerCompanyManageModal.complianceUsersModal.errors.email')
      }
    }

    if (Object.keys(errorsToSet).length > 0) {
      setErrors({ ...errorsToSet })
      return
    }

    handleCreateCustomerCompanyComplianceUser({ userEmailData, userLastNameData, userFirstNameData })
  }

  return (
    <Dialog
      errors={errors as FormError}
      dialogIsLoading={isLoading}
      handleDialogOpenState={(openState: boolean) => {
        if (isLoading) return

        handleOpenStateOfModal(openState)

        if (openState === false) {
          setErrors(null)
          setUserEmailData('')
          setUserLastNameData('')
          setUserFirstNameData('')
        }
      }}
      handleDialogAction={handleSubmitPocketDataCreation}
      dialogTitle={t('customerCompanyManageModal.complianceUsersModal.title')}
      actionButtonText={t('customerCompanyManageModal.complianceUsersModal.actionButtonText')}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <TextField
            fullWidth
            variant="standard"
            sx={textFieldWhiteBg}
            value={userFirstNameData || ''}
            error={!!errors?.userFirstNameData}
            helperText={errors?.userFirstNameData}
            onChange={(event) => setUserFirstNameData(event.target.value.toUpperCase())}
            label={t('customerCompanyManageModal.complianceUsersModal.textFieldLabels.firstName')}
          />
          <TextField
            fullWidth
            variant="standard"
            sx={textFieldWhiteBg}
            value={userLastNameData || ''}
            error={!!errors?.userLastNameData}
            helperText={errors?.userLastNameData}
            onChange={(event) => setUserLastNameData(event.target.value.toUpperCase())}
            label={t('customerCompanyManageModal.complianceUsersModal.textFieldLabels.lastName')}
          />
        </div>
        <div>
          <TextField
            fullWidth
            variant="standard"
            sx={textFieldWhiteBg}
            value={userEmailData || ''}
            error={!!errors?.userEmailData}
            helperText={errors?.userEmailData}
            onChange={(event) => setUserEmailData(event.target.value.toLowerCase())}
            label={t('customerCompanyManageModal.complianceUsersModal.textFieldLabels.email')}
          />
        </div>
      </div>
    </Dialog>
  )
}
